import { isScreenshotEntrypoint } from '../../config'
import { isTextureReady } from './textureUtils'
import type * as THREE from 'three'

export type BedPbrMaps = {
  base: THREE.Texture | null
  normal?: THREE.Texture | null
  roughness?: THREE.Texture | null
  metalness?: THREE.Texture | null
  ao?: THREE.Texture | null
  displacement?: THREE.Texture | null
}

let readinessVersion = 0

/** The Frame API waits on this flag for /screenshot only. */
function publishScreenshotBedRenderReady(ready: boolean) {
  if (typeof window === 'undefined' || !isScreenshotEntrypoint()) return
  ;(window as any).__bed_render_ready__ = ready
}

export function setScreenshotBedRenderReady(ready: boolean) {
  readinessVersion++
  publishScreenshotBedRenderReady(ready)
}

export function textileMapsAreGpuReady(maps: BedPbrMaps | null | undefined): boolean {
  return !!maps?.base && isTextureReady(maps.base)
}

export function allTextileMapsAreGpuReady(
  entries: Array<{ maps: BedPbrMaps }>,
): boolean {
  return entries.length > 0 && entries.every((entry) => textileMapsAreGpuReady(entry.maps))
}

/** After materials are applied, wait two frames so GPU uploads can finish before capture. */
export function signalScreenshotBedRenderReadyAfterApply(
  textileReady: boolean,
  options?: { bestEffort?: boolean },
) {
  // Clear an earlier success immediately and invalidate its queued callbacks.
  setScreenshotBedRenderReady(false)
  const version = readinessVersion
  if (!textileReady && !options?.bestEffort) {
    return
  }
  requestAnimationFrame(() => {
    if (version !== readinessVersion) return
    requestAnimationFrame(() => {
      if (version !== readinessVersion) return
      publishScreenshotBedRenderReady(true)
      if (options?.bestEffort) {
        console.warn(
          '[BedModel] screenshot bed_render_ready: best-effort (textiles missing or not GPU-ready)',
        )
      }
    })
  })
  return () => {
    if (version === readinessVersion) setScreenshotBedRenderReady(false)
  }
}
